import type { CSSProperties } from "react";

export const getClipPathStyle = (clipPathId: string): CSSProperties => {
    return {
        clipPath: `url(#${clipPathId})`,
    };
};
